import React from 'react';
import appConstants from '../../../appConstants';
import { getCustomerAndShipperComment } from '../utils';

/**
 * Processes customer data to extract unique equipment sizes and routes
 * @param {Array} customerData - Array of customer objects containing delivery details
 * @returns {Object} Object containing arrays of unique equipment sizes and routes
 */
export const getUniqueCustomerFilterData = (customerData) => {
  const maxEquipSizes = new Set();
  const minEquipSizes = new Set();
  const fixedEquipSizes = new Set();
  const overrideRoutes = new Set();
  
  customerData.forEach((customer) => {
    const { maxEquipmentSize, minEquipmentSize, fixedEquipmentSize, route } = customer.deliveryDetails;
    maxEquipmentSize && maxEquipSizes.add(maxEquipmentSize);
    minEquipmentSize && minEquipSizes.add(minEquipmentSize);
    fixedEquipmentSize && fixedEquipSizes.add(fixedEquipmentSize);
    route && overrideRoutes.add(route);
  });

  return {
    maxEquipSizes: Array.from(maxEquipSizes),
    minEquipSizes: Array.from(minEquipSizes),
    fixedEquipSizes: Array.from(fixedEquipSizes),
    overrideRoutes: Array.from(overrideRoutes),
  };
};

/**
 * Processes customer data to extract unique equipment sizes and routes
 * @param {Array} customerData - Array of customer objects containing pickup details
 * @returns {Object} Object containing arrays of unique equipment sizes and routes
 */
export const getUniqueShipperFilterData = (shipperData) => {
    const maxEquipSizes = new Set();
    const minEquipSizes = new Set();
    const fixedEquipSizes = new Set();
    
    shipperData.forEach((shipper) => {
      const { maxEquipmentSize, minEquipmentSize, fixedEquipmentSize } = shipper.pickupDetails;
      maxEquipmentSize && maxEquipSizes.add(maxEquipmentSize);
      minEquipmentSize && minEquipSizes.add(minEquipmentSize);
      fixedEquipmentSize && fixedEquipSizes.add(fixedEquipmentSize);
    });
  
    return {
      maxEquipSizes: Array.from(maxEquipSizes),
      minEquipSizes: Array.from(minEquipSizes),
      fixedEquipSizes: Array.from(fixedEquipSizes),
    };
  };
  

const getSpecialNeedsData = ({ data, isDelivery, featureFlags }) => {
  const { isLiftGateRequired, isApt, isTrailerBackFill, isUnattendedDelivery, isTrailerSwap, specialInstruction } =
    data;

  const { customerComments, shipperComments } = featureFlags?.enableCommentsForCustomer
    ? getCustomerAndShipperComment({ ...data, isDelivery })
    : { customerComments: null, shipperComments: null };

  const liftgate = isLiftGateRequired ? appConstants.SpecialNeedsStrings.L : '';
  const trailerBackFill = isTrailerBackFill ? appConstants.TRAILER_BACKFILL.YES : '';
  const apt = isApt ? appConstants.SpecialNeedsStrings.APT : '';
  return {
    apt,
    liftgate,
    specialInstruction,
    customerComments,
    shipperComments,
    isDelivery,
    isTrailerSwap,
    isUnattendedDelivery,
    isTrailerBackFill: trailerBackFill
  };
};

const getEquipmentSizeTooltipContent = ({
  maxEquipmentSize,
  minEquipmentSize,
  fixedEquipmentSize
}) => {
  const sizeMap = {
    'Fixed Size': fixedEquipmentSize,
    'Max Size': maxEquipmentSize,
    'Min Size': minEquipmentSize
  };

  return (
    <div>
      {Object.entries(sizeMap)
        .filter(([_, val]) => val)
        .map(([label, val], index) => (
          <div key={index}>{`${label}: ${val}`}</div>
        ))}
    </div>
  );
};

export { getSpecialNeedsData, getEquipmentSizeTooltipContent };
